import { Component, OnInit } from '@angular/core';
import { SettingService } from '../../services/setting.service';
import { Subscription } from 'rxjs';
import { Settings, Setting } from '../../interfaces/setting';


@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.scss']
})

export class SettingComponent implements OnInit {

  settingsData:any = [];
  settingSubscrition: Subscription;

  constructor(
    private settingService: SettingService
  ) { }

  addNewSetting(){
    let newSettingData = {
      alias: "",
      label: "",
      value: ""
    };

    this.settingsData.unshift(newSettingData);
  };

  ngOnInit(): void {
    this.settingSubscrition = this.settingService.settings.subscribe((settings: Settings) => {
      this.settingsData = settings;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/setting/setting.component.ts